import { css, jsx } from '@emotion/core';
import { Input } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { handleFormChange } from '@/src/register/redux/registerAccountReducer';
import Form from '@/src/shared/components/Form';
import { pciEveryone } from '@/src/shared/constants';
import { bp, colors } from '@/styles';

const styles = {
  inputContainer: (bool = false) => css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
    .ant-input {
      border-width: 1px;
      border-style: solid;
      border-color: rgb(218, 217, 215);
    }
  `,
};

const { TextArea } = Input;

const TextInput = ({ form, info, step, currentInfo, key, onChange }) => {
  const { label, field, formOverrides = {} } = info;

  const { register } = useSelector(state => state);
  const { role } = useSelector(state => state.auth);
  const isAdmin = Array.isArray(role) && role.includes(pciEveryone);
  const dispatch = useDispatch();

  return (
    <div key={key} css={styles.inputContainer}>
      {isAdmin && (
        <Form.Item label={label}>
          {form.getFieldDecorator(field, {
            initialValue: register[field],
            ...formOverrides,
            rules: [{ required: false }],
          })(
            <TextArea
              rows={4}
              onChange={e => {
                onChange(field, e);
              }}
            />
          )}
        </Form.Item>
      )}
    </div>
  );
};

TextInput.defaultProps = {
  formOverrides: {},
  onChange: () => {},
  isMailing: false,
};
export default TextInput;
